<template>
  <article>
    <div :class="['toasts', { hide: hasFlaggedItems }]">
      <div class="toast" v-for="item in items" :key="item.id" :id="item.id">
        <div class="toast-body">
          <i class="icon icon-check" />
          {{$t(`${item.body}`)}}
        </div>
      </div>
    </div>
    {{this.getToast.isOpen === true ? this.click() : ""}}
  </article>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters("auth/commMotpCertn", ["getToast"]),
    hasFlaggedItems() {
      return this.items.some(i => i.flaggedForRemoval);
    },
  },
  methods: {
    click() {
      const toast = {
        id: Date.now(),
        body: this.$store.state.auth.commMotpCertn.Toast.contents,
        flaggedForRemoval: false,
      };

      this.items.unshift(toast);
      setTimeout(() => this.close(toast), 2000); // toast 머무는 시간
      this.$store.state.auth.commMotpCertn.Toast.isOpen = false; // toast 실행정지.
    },
    close(toast) {
      const index = this.items.indexOf(toast);
      this.items.splice(index, 1);
      toast.flaggedForRemoval = true;

      document.getElementById(toast.id).addEventListener("transitionend", () => this.remove(toast));
    },
    remove(toast) {
      const index = this.items.indexOf(toast);
      this.items.splice(index, 1);
    },
  },
};
</script>
